var map = {
	"./title-cn.png": "iYrY",
	"./title-en.png": "FGx8",
	"./title-th.png": "Veyi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pMdb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/title ^\.\/title\-.*\.png$
// module id = pMdb
// module chunks = 1